module.exports = __webpack_public_path__ + "static/media/4@1024w.eaa7b6d1.jpg";